<template>
  <div
    :key="route.name"
    class="flex-y-center gap-1 text-sm md:text-base text-gray-450 font-semibold"
  >
    <template v-if="route.name && route.name.toString().includes('AuthLogin')">
      <p>{{ $t("have_account") }}</p>
      <LocalizedLink
        to="/auth/register"
        class="text-dark cursor-pointer transition-200 hover:text-green"
      >
        {{ $t("register") }}
      </LocalizedLink>
    </template>
    <template v-else>
      <p>{{ $t("are_you_member") }}</p>
      <LocalizedLink
        to="/auth/login"
        class="text-dark cursor-pointer transition-200 hover:text-green"
      >
        {{ $t("enter_system") }}
      </LocalizedLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import LocalizedLink from "@/components/CLocalizedLink.vue";

const route = useRoute();
</script>

<style scoped></style>
